import { useState } from "react";

const UploadModal = ({ isOpen, setIsOpen, handleUploadFile, file, setFile }) => {
  const [selectedFile, setSelectedFile] = useState(null);

  if (!isOpen) return null;

  const handleFileChange = (e) => {
    const chosenFile = e.target.files[0];
    setSelectedFile(chosenFile);
    setFile(chosenFile); // Also update parent state
  };

  const handleUpload = () => {
    handleUploadFile(selectedFile); // Pass the file directly
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="w-full p-6 bg-white rounded-lg shadow-xl sm:w-96 space-y-5">
        <h2 className="mb-5 text-xl font-semibold text-center text-gray-800">
          Upload Excel File
        </h2>

        <label className="flex flex-col items-center justify-center w-full p-5 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition">
          <span className="text-gray-600 font-medium">
            {selectedFile ? selectedFile.name : "Click to select Excel file"}
          </span>
          <span className="text-xs text-gray-400 mt-1">(.xlsx or .xls)</span>

          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
            className="hidden"
          />
        </label>

        <div className="flex justify-between gap-4">
          <button
            className="w-full py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100"
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </button>

          <button
            className="w-full py-2 text-white bg-violet-700 rounded-md hover:bg-violet-800"
            onClick={handleUpload}
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};


export default UploadModal;